var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { User } from '@/models/User';
import Roster from '@/components/roster/Roster';
import NotificationsCard from '@/components/notifications-card/NotificationsCard';
import Bookmarks from '@/components/bookmarks/Bookmarks';
import DataTable from '@/components/data-table/DataTable';
import ErrorHandler from '@/support/ErrorHandler';
import { Student } from '@/models/Student';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { excludeRoles } from '@/support/ExcludeRoles';
let Dashboard = class Dashboard extends Vue {
    constructor() {
        super(...arguments);
        this.selectedGroupId = null;
        this.groups = [];
        this.users = [];
        this.content = '';
        this.activeTab = '';
    }
    get editorOptions() {
        return {
            modules: {
                magicUrl: true,
            },
            placeholder: 'Voeg hier je tekst in ...',
        };
    }
    get tableOptionsCoach() {
        return {
            name: {
                singular: 'Coach group',
                plural: 'Coach groups',
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: '/students/{id}/finished',
                },
                {
                    text: this.$tc('subject.topic.title', 2),
                    value: 'parent',
                },
            ],
            model: new Student()
                .filter('group', this.selectedGroupId ? this.selectedGroupId : null)
                .include('parent')
                .filter('statuses', 'finished'),
        };
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.save', { item: this.$t('dialogOptions.item.note') }).toString(),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.user.include('note').update({ note: this.content }).catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
            },
        };
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.dashboard.includes(this.$store.state.Auth.roles[0].id);
    }
    mounted() {
        this.fetchUser();
        this.initialize();
        this.$root.$on('locale-changed', this.switchQuillLanguage);
    }
    initialize() {
        // new Group()
        //   .include(['users'])
        //   .filter({ type: 'coach', users: [this.$store.state.Auth.id] })
        //   .all()
        //   .then((groups: Group[]) => {
        //     this.groups = groups;
        //     if(groups.length) {
        //       this.selectedGroupId = groups[0].id || '';
        //       this.activeTab = '0';
        //     }
        //   })
        //   .catch((error: AxiosError) => {
        //     ErrorHandler.network(error);
        //   });
    }
    onEditorBlur(quill) {
        //
    }
    onEditorFocus(quill) {
        //
    }
    onEditorReady(quill) {
        //
    }
    onEditorChange(quill, html, text) {
        this.content = html;
    }
    save() {
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    onSaveBookmark(bookmarkUrl) {
        // comunicate to bookmarks
        if (this.$refs.bookmarks) {
            const bookmarksVue = this.$refs.bookmarks;
            bookmarksVue.selectedBookmark = {
                link: bookmarkUrl,
            };
            bookmarksVue.isShowingCreateDialog = true;
        }
    }
    fetchUser() {
        if (!this.user) {
            return;
        }
        new User()
            .include('note')
            .find(this.user.id)
            .then((user) => {
            if (typeof user.note === 'string') {
                this.content = user.note;
                return;
            }
            else {
                this.content = user.note.text || '';
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    switchQuillLanguage() {
        const editor = this.$refs.studentNotesEditor;
        if (!editor) {
            return;
        }
        const placeholder = this.$t('quillEditor.placeholder').toString();
        editor.quill.root.dataset.placeholder = placeholder;
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Dashboard.prototype, "student", void 0);
__decorate([
    Prop({ default: new User() }),
    __metadata("design:type", typeof (_b = typeof User !== "undefined" && User) === "function" ? _b : Object)
], Dashboard.prototype, "user", void 0);
Dashboard = __decorate([
    Component({
        components: {
            DataTable,
            NotificationsCard,
            Bookmarks,
            Roster,
            quillEditor,
        },
    })
], Dashboard);
export default Dashboard;
